import React, { Component } from 'react';
import ReactTable from 'react-table';
import reqwest from 'reqwest';
import moment from 'moment';

import history from '../../history';
import settings from '../../../settings';
import Loader from '../../components/Loader';
import Searchbar from '../../components/Searchbar';

class DutyRosterOverview extends Component {
  constructor(props) {
    super(props);

    let searchString = '';
    if (props.match.params.search) {
      searchString = props.match.params.search;
    }

    this.state = {
      loading: true,
      data: [],
      searchString,
    };
  }

  componentDidMount() {
    const promise = reqwest({
      method: 'get',
      url: settings.office.general.getList,
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(res => {
      this.setState({
        data: JSON.parse(res).officeList,
      });
    });

    Promise.all([promise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  _search = value => {
    const val = value.toLowerCase();

    history.replace(val ? `/officemanagement/search/${val}` : '/officemanagement');

    this.setState({
      searchString: val,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.data.filter(rowData =>
      [rowData.CCR, rowData.Name]
        .map(e => e.toLowerCase())
        .some(v => {
          return v.indexOf(this.state.searchString) >= 0;
        }),
    );

    return (
      <>
        <div className='Toolbar'>
          <Searchbar placeholder='Büro suchen...' defaultValue={this.state.searchString} onChange={this._search} />
          <div className='Toolbar-buttons'></div>
        </div>
        <ReactTable
          getTrProps={(_, { original }) => ({
            onClick: () => this.props.history.push(`/dutyroster/${original.Guid}/${moment().format('YYYY')}/${moment().format('M')}`),
          })}
          data={data}
          pageSize={data.length}
          noDataText='Es wurden keine Büros gefunden.'
          columns={[
            {
              Header: 'KST',
              accessor: 'CCR',
              maxWidth: 200,
            },
            {
              Header: 'Name',
              accessor: 'Name',
            },
          ]}
        />
      </>
    );
  }
}

export default DutyRosterOverview;
